import React, {useContext} from 'react';
import Grid from '@mui/material/Grid';
import SecondaryButton from '../../../common/StyledComponents/SecondaryButton';
import PrimaryButton from '../../../common/StyledComponents/PrimaryButton';
import {NewProjectContext} from '../utils/NewProjectContext';
import Button from '@mui/material/Button';
import {makeStyles} from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';

interface IProps {
  secondaryAction: () => void;
  secondaryLabel?: string;
  primaryAction: () => void;
  primaryLabel?: string;
  loading?: boolean;
  disabled?: boolean;
}

const useStyles = makeStyles(() => ({
  homeDepotSecondaryButton: {
    width: '48%',
    textTransform: 'capitalize',
    fontSize: 16,
    fontWeight: 700,

    color: '#666',
    backgroundColor: '#FFF',
    borderRadius: 2,
    border: '3px solid #666',
    '&:hover': {
      color: '#FFF',
      backgroundColor: '#666',
    },
  },
  homeDepotPrimaryButton: {
    width: '48%',
    textTransform: 'capitalize',
    fontSize: 16,
    fontWeight: 700,

    color: '#FFF',
    backgroundColor: '#CB4814',
    borderRadius: 2,
    border: '3px solid transparent',
    '&:hover': {
      backgroundColor: '#A23A10',
    },
    '&:disabled': {
      color: '#666',
      backgroundColor: '#E5E5E5',
      fontWeight: 400,
      fontStyle: 'italic',
    },
  },
}));

const ActionButtons = ({
  secondaryAction,
  secondaryLabel = 'BACK',
  primaryAction,
  primaryLabel = 'NEXT',
  loading,
  disabled,
}: IProps) => {
  const classes = useStyles();
  const {homeDepot} = useContext(NewProjectContext);

  if (homeDepot) {
    return (
      <Grid my={3} container alignItems="center" justifyContent="space-between">
        <Button
          onClick={secondaryAction}
          className={classes.homeDepotSecondaryButton}>
          {secondaryLabel.toLowerCase()}
        </Button>
        <Button
          onClick={primaryAction}
          className={classes.homeDepotPrimaryButton}
          disabled={disabled || loading}>
          {loading ? (
            <CircularProgress size={28} />
          ) : (
            primaryLabel.toLowerCase()
          )}
        </Button>
      </Grid>
    );
  }

  return (
    <Grid my={3} container alignItems="center">
      <SecondaryButton onClick={secondaryAction} style={{marginRight: 12}}>
        {secondaryLabel}
      </SecondaryButton>
      <PrimaryButton
        onClick={primaryAction}
        disabled={disabled}
        loading={loading}>
        {primaryLabel}
      </PrimaryButton>
    </Grid>
  );
};

export default ActionButtons;
